import {
    BRANCH_CONTACT_DETAILS_DISPLAY_ACTION,
    BRANCH_DEVICE_GRID_DISPLAY_ACTION,
    BRANCH_GRID_DISPLAY_ACTION,
    DELIVERY_METHOD_DISPLAY_ACTION,
    DEREGISTRATION_LINK_DISPLAY_ACTION,
    DEVICE_GRID_DISPLAY_ACTION
} from "../../../actionType";


export default function (state = {deviceGridDisplay:false,
    branchGridDisplay:false,
    branchDeviceGridDisplay:false,
    branchContactDetailsDisplay:false,
    deliveryMethodDisplay:false,
    deregistrationLinkDisplay:false}, action) {
    switch (action.type) {
        case DEVICE_GRID_DISPLAY_ACTION:
            return {
                ...state,
                deviceGridDisplay:action.deviceGridDisplay,
            };
        case BRANCH_GRID_DISPLAY_ACTION:
            return {
                ...state,
                branchGridDisplay:action.branchGridDisplay,
            };
        case BRANCH_DEVICE_GRID_DISPLAY_ACTION:
            return {
                ...state,
                branchDeviceGridDisplay:action.branchDeviceGridDisplay,
            };
        case BRANCH_CONTACT_DETAILS_DISPLAY_ACTION:
            return {
                ...state,
                branchContactDetailsDisplay:action.branchContactDetailsDisplay,
            };
        case DELIVERY_METHOD_DISPLAY_ACTION:
            return {
                ...state,
                deliveryMethodDisplay:action.deliveryMethodDisplay,
            };
        case DEREGISTRATION_LINK_DISPLAY_ACTION:
            return {
                ...state,
                deregistrationLinkDisplay:action.deregistrationLinkDisplay,
            };
        default:
            return state;
    }
}
